import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhoneInputComponent } from './components/phone-input';
import { ReactiveFormsModule } from '@angular/forms';
import { ItiPhoneInputDirective } from './components/phone-input/iti-phone-input.directive';


/**
 * A module providing a phone number input and processing.
 *
 * Requires the following optional peer dependencies:
 * • intl-tel-input
 */
@NgModule({
  declarations: [
    PhoneInputComponent,
    ItiPhoneInputDirective,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
  ],
  exports: [
    PhoneInputComponent,
  ]
})
export class NomidioPhoneModule { }
